export default __webpack_public_path__ + "static/media/parttime.86afb8eb.png";